import * as React from 'react';
import Card from './Card';
import '../css/referral-tile.sass';
import { ActionButton } from './ActionButtons';
import CampfireButton from './CampfireButton';

interface ReferralTileProps {
  id: string;
  imageUrl: string;
  description: string;
  button?: ActionButton;
  disclaimer?: React.ReactNode;
}

export default function ReferralTile(props: ReferralTileProps) {
  const { button } = props;
  return (
    <div id={props.id} className="referral-tile">
      <Card>
        <img src={props.imageUrl} alt="" />
        <div className="description">{props.description}</div>
        {button && (
          <CampfireButton
            name={`referralBtn-${props.id}`}
            theme={button.theme}
            id={`${button.id}`}
            label={button.label}
            onClick={(e: any) => {
              if (button.onClick !== undefined) {
                button.onClick(e);
              }
            }}
            onKeyDown={button.onKeyDown}
            disabled={button.disabled}
            smol={button.smol}
            title={button.title}
            sendTo={button.sendTo}
            focus={button.focus}
            style={button.style}
          />
        )}
        {props.disclaimer && (
          <div className="disclaimer">{props.disclaimer}</div>
        )}
      </Card>
    </div>
  );
}
